import { useNavigate } from "react-router-dom";
import { MapPinIcon, XIcon } from "@phosphor-icons/react";
import { useState } from "react";
import ikas from "../../providers/ikas";
import * as compSettings from "./settings";

const Addresses = ({ id, extendedSettings, data, dataSetter }) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Ayarları değişkenlere dönüştür
  const backgroundColor = settings.backgroundColor?.value;
  const borderRadius = settings.borderRadius?.value;
  const boxShadow = settings.boxShadow?.value;
  const padding = settings.padding?.value;
  const addressTextColor = settings.addressTextColor?.value;
  const addressTextSize = settings.addressTextSize?.value;
  const iconColor = settings.iconColor?.value;
  const iconSize = settings.iconSize?.value || 24;
  const showDeleteButton = settings.showDeleteButton?.value !== false;
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");

  const addresses = data?.customer?.addresses;

  const handleAddAddress = () => {
    navigate("/account/address/upsert");
  };
  const handleEditAddress = (address) => {
    navigate(`/account/address/upsert`, {
      state: address,
    });
  };
  const handleDeleteAddress = (address) => {
    setAddressToDelete(address);
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    setShowDeleteModal(false);
    setLoading(true);
    try {
      const newAddressesArr = addresses.filter(
        (a) => a.id !== addressToDelete.id
      );
      const result = await ikas.saveMyCustomer({
        firstName: data.customer.firstName,
        lastName: data.customer.lastName,
        addresses: newAddressesArr,
      });
      dataSetter(result);

      setToastType("success");
      setToast("Adres silme onaylandı");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => setToast(""), 400);
      }, 1200);
    } catch (e) {
      console.log(e);
      setToastType("error");
      setToast("Adres silinirken bir hata oluştu.");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => setToast(""), 400);
      }, 1800);
    }
    setLoading(false);
    setAddressToDelete(null);
  };
  const cancelDelete = () => {
    setShowDeleteModal(false);
    setAddressToDelete(null);
  };

  return (
    <div
      style={{ position: "relative", paddingBottom: 96, minHeight: "100vh" }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 640,
          minWidth: 200,
          display: "flex",
          flexDirection: "column",
          gap: 16,
          padding: padding,
          margin: "0 auto",
          paddingBottom: 96,
        }}
      >
        {addresses.length === 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 48,
              paddingBottom: 48,
              color: "#6b7280",
            }}
          >
            <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
              <circle cx="32" cy="32" r="30" stroke="#e4e4e4" strokeWidth="4" />
              <path
                d="M44 44L54 54"
                stroke="#bdbdbd"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <circle cx="30" cy="30" r="12" stroke="#bdbdbd" strokeWidth="3" />
            </svg>
            <div
              style={{
                marginTop: 16,
                fontSize: 18,
                fontWeight: 600,
                color: "#374151",
              }}
            >
              Adres bulunamadı
            </div>
            <div
              style={{
                fontSize: 14,
                color: "#9ca3af",
                marginTop: 4,
                textAlign: "center",
              }}
            >
              Henüz bir adres eklemediniz.
              <br />
              Yeni bir adres ekleyin.
            </div>
          </div>
        ) : (
          addresses.map((address, index) => (
            <div
              onClick={() => handleEditAddress(address)}
              key={index}
              style={{
                width: "100%",
                padding: padding,
                background: backgroundColor,
                display: "flex",
                gap: 8,
                alignItems: "center",
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                position: "relative",
                transition: "box-shadow 0.3s",
              }}
            >
              <MapPinIcon
                style={{
                  width: iconSize,
                  height: iconSize,
                  color: iconColor,
                  marginBottom: 8,
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  flex: 1,
                  color: addressTextColor,
                  fontSize: addressTextSize,
                }}
              >
                <h3 style={{ fontSize: addressTextSize, fontWeight: 600 }}>
                  {address.title}
                </h3>
                <p>
                  {address.addressLine1} {address.addressLine2}
                </p>
                <p>
                  {address.city.name} / {address.district.name}
                </p>
              </div>
              {showDeleteButton && (
                <button
                  style={{
                    padding: 4,
                    borderRadius: "50%",
                    color: iconColor,
                    position: "absolute",
                    right: 4,
                    top: 8,
                    background: "none",
                    border: "none",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteAddress(address);
                  }}
                  title="Sil"
                >
                  <XIcon
                    style={{ width: iconSize - 4, height: iconSize - 4 }}
                  />
                </button>
              )}
            </div>
          ))
        )}
      </div>

      <div
        style={{
          width: "100%",
          maxWidth: 640,
          minWidth: 200,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 16,
          margin: "0 auto",
          paddingLeft: 8,
          paddingRight: 8,
          position: "fixed",
          left: "50%",
          transform: "translateX(-50%)",
          bottom: 40,
          zIndex: 20,
        }}
      >
        <button
          style={{
            width: "100%",
            fontSize: 18,
            background: "#000",
            color: "#fff",
            padding: 12,
            borderRadius: 10,
            textAlign: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            border: "none",
            fontWeight:700
          }}
          onClick={handleAddAddress}
        >
          Adres Ekle
        </button>
      </div>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: 48,
              height: 48,
              border: "4px solid #fff",
              borderTopColor: "transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              display: "inline-block",
            }}
          ></span>
        </div>
      )}
      {showDeleteModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.4)",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 24,
              boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: 280,
              maxWidth: 384,
              width: "100%",
              border: "1px solid #f3f4f6",
            }}
          >
            <div
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: "#1f2937",
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              Adresi silmek istediğinize emin misiniz?
            </div>
            <div
              style={{ display: "flex", gap: 12, width: "100%", marginTop: 8 }}
            >
              <button
                style={{
                  flex: 1,
                  paddingTop: 8,
                  paddingBottom: 8,
                  borderRadius: 12,
                  background: "#ef4444",
                  color: "#fff",
                  fontWeight: 600,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  border: "none",
                  transition: "background 0.2s",
                }}
                onClick={confirmDelete}
              >
                Evet
              </button>
              <button
                style={{
                  flex: 1,
                  paddingTop: 8,
                  paddingBottom: 8,
                  borderRadius: 12,
                  background: "#f3f4f6",
                  color: "#374151",
                  fontWeight: 600,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  border: "1px solid #e5e7eb",
                  transition: "background 0.2s",
                }}
                onClick={cancelDelete}
              >
                Hayır
              </button>
            </div>
          </div>
        </div>
      )}
      {toast && (
        <div
          style={{
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 100,
            width: "95vw",
            maxWidth: 640,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 12,
            paddingBottom: 12,
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            fontSize: 16,
            fontWeight: 600,
            textAlign: "center",
            transition: "all 0.4s",
            top: data?.system?.safeArea?.top ?? 20,
            minWidth: 320,
            backgroundColor: toastType === "error" ? "#ef4444" : "#6f59ef",
            color: "#fff",
            opacity: showToast ? 1 : 0,
            pointerEvents: showToast ? "auto" : "none",
            marginTop: showToast ? 0 : -16,
          }}
        >
          {toast}
        </div>
      )}
    </div>
  );
};
export default Addresses;
